<template>
  <article class="kd-card kd-card--course-card">
    <div class="kd-card--course-card__discount-container" v-if="showDiscount">
      <span class="kd-card--course-card__discount-amount">
        {{course.discount}} OFF!
      </span>
    </div>

    <div class="kd-card--course-card__header-bar" v-if="showProgramTag">
      <div class="kd-card--course-card__program-tag" aria-hidden="true">
        <i class="kf kf-programs-icon"></i>
      </div>
    </div>

    <div class="kd-card__entry-thumb">
      <a @click="courseAction" :href="courseActionLink" class="kd-card__entry-thumb_link" data-skip-pjax="true" aria-hidden="true" tabindex="-1">
        <span class="sr-only">{{ course.full_name }}</span>

        <div class="kd-card__img_hover-overlay">
          <i class="kf kf-eye"></i>
        </div>
      </a>

      <img :src="course.logo" alt="Course Image" class="kd-card__img img-responsive">

      <aside class="kd-card__status-overlay">
        <template v-if="!course.current_user">
          <div class="kd-card__status-overlay_state">
            <span>{{ course.time_status }}</span>

            <template v-if="Kadenze.isKadenze">
              <template v-if="(course.for_credit || course.program_for_credit)">
                &mdash; {{ i18nTranslations('course.info.enrollment_type.credit') }}
              </template>

              <template v-else-if="course.micro_course">
                &mdash; {{ i18nTranslations('course_card.micro_course') }}
              </template>
            </template>
          </div>
          <div class="kd-card__status-overlay_date">
            <span>{{ course.date_range }}</span>
          </div>
        </template>

        <div v-if="course.current_user && !invited">
          <div v-if="showUserStatus">
            <div class="kd-card__status-overlay_state" v-if="completed">
              <span v-html="require('!html-loader!images/svg/svg-icons/checkmark_filled.svg')"></span>
              <span>{{i18nTranslations('learning_module.criteria_options.completed')}}</span>
            </div>

            <div class="kd-card__status-overlay_state" v-else-if="draft">
              <span v-html="require('!html-loader!images/svg/svg-icons/checkmark_filled.svg')"></span>
              <span>{{i18nTranslations('site_alert.draft')}}</span>
            </div>

            <div class="kd-card__status-overlay_state" v-else-if="pending">
              <span v-html="require('!html-loader!images/svg/svg-icons/clock_filled.svg')"></span>
              <span>{{i18nTranslations('course_card.pending_approval')}}</span>
            </div>

            <div class="kd-card__status-overlay_state" v-else-if="cloning">
              <span v-html="require('!html-loader!images/svg/svg-icons/clock_filled.svg')"></span>
              <span>{{i18nTranslations('course_card.cloning_data')}}</span>
            </div>

            <div class="kd-card__status-overlay_state" v-else-if="denied">
              <!-- <span v-html="require('!html-loader!images/svg/svg-icons/warning-filled.svg')"></span> -->
              <span>{{i18nTranslations('course_card.denied')}}</span>
            </div>

            <div class="kd-card__status-overlay_state" v-else-if="archived">
              <span v-html="require('!html-loader!images/svg/svg-icons/archived_filled.svg')"></span>
              <span>Archived</span>
              <span v-if="course.term_name"> &mdash; {{course.term_name}}</span>
            </div>

            <div class="kd-card__status-overlay_state" v-else>
              <span>{{ course.time_status }}</span>

              <template v-if="Kadenze.isKadenze">
                <template v-if="(course.for_credit || course.program_for_credit)">
                  &mdash; {{ course.current_user.is_for_credit ? i18nTranslations('course_card.enrolled_as_credit_eligible') : i18nTranslations('course.info.enrollment_type.credit') }}
                </template>

                <template v-else-if="course.micro_course">
                  &mdash; {{ i18nTranslations('course_card.micro_course') }}
                </template>
              </template>
            </div>
            
            <div class="kd-card__status-overlay_state" v-if="!enrolled">
              <span>{{ course.date_range }}</span>
            </div>
          </div>
          <div v-else>
            <div class="kd-card__status-overlay_state">
              <span>{{ course.time_status }}</span>
              <template v-if="Kadenze.isKadenze">
                <template v-if="(course.for_credit || course.program_for_credit)">
                  &mdash; {{ (course.current_user && course.current_user.is_for_credit) ? i18nTranslations('course_card.enrolled_as_credit_eligible') : i18nTranslations('course.info.enrollment_type.credit') }}
                </template>
              </template>
            </div>
            <div class="kd-card__status-overlay_date" v-if="!enrolled">
              <span>{{ course.date_range }}</span>
            </div>            
          </div>
        </div>
      </aside>
    </div>

    <header class="kd-card__info">
      <a @click="courseAction" :href="courseActionLink" class="kd-card__info_course-title" aria-hidden="true" tabindex="-1" data-skip-pjax="true">
        <span>{{ course.full_name }}</span>
      </a>

      <div class="kd-card__info_school" v-if="Kadenze.isKadenze">{{ course.institution_name }}</div>

      <div class="kd-card__info_instructors">{{ instructorsText }}</div>
    </header>

    <footer class="kd-card__footer">
      <div class="kd-card__footer_secondary" v-if="publicBrowseEnabled">
        <a href="javascript:;" class="kd-ibtn" aria-label="Share" @click="share" v-tooltip="{content: 'Share'}" aria-hidden="true" tabindex="-1">
          <i class="kf kf-share"></i>
        </a>
      </div>

      <div class="kd-card__footer_primary">
        <a @click="courseAction" :href="courseActionLink" class="kd-card__primary-link" tabindex="-1" data-skip-pjax="true">
          <span>{{ courseActionText }}</span>
          <span class="sr-only">{{ course.full_name }}</span>
        </a>
      </div>
    </footer>
  </article>
</template>

<script type="text/javascript">
export default {
  name: "CourseCard",

  props: ['course', 'showUserStatus', 'publicBrowseEnabled'],

  computed: {
    draft() {
      return this.course.is_draft || this.course.is_cloning;
    },

    upcoming() {
      return this.course.is_upcoming || this.course.is_pending;
    },

    archived() {
      if (this.course.current_user) {
        return this.course.is_ended || this.course.current_user.is_archived;
      } else {
        return this.course.is_ended;
      }
    },

    showProgramTag() {
      return this.course.in_program;
    },

    invited() {
      return this.course.current_user && this.course.current_user.is_invited;
    },

    completed() {
      return this.course.is_completed;
    },

    pending() {
      return this.course.is_pending;
    },

    cloning() {
      return this.course.is_cloning;
    },

    denied() {
      return this.course.is_denied;
    },

    ended() {
      return this.course.is_ended;
    },

    enrolled() {
      return this.course.current_user && this.course.current_user.is_enrolled;
    },

    locked() {
      return this.course.current_user.is_locked;
    },

    is_instructor_or_admin() {
      return this.course.current_user.is_instructor || this.course.current_user.is_admin
    },

    showDiscount() {
      return ((typeof(this.course.current_user) == 'undefined') || !this.enrolled) && 
        this.course.discount && 
          (this.course.micro_course || 
            (this.course.in_program && this.course.program_only) || 
              this.course.standard_course);
    },

    courseActionLink() {
      let path = this.course.course_info_path;

      if (this.course.current_user) {
        if (this.course.current_user.is_student) {
          if (this.archived || this.upcoming) {
            path = this.course.course_info_path;
          } else if (!this.locked && !this.course.is_cohort_locked) {
            path = this.course.course_path;
          }
        } else if (this.is_instructor_or_admin) {
          path = this.course.course_path;
        }
      }

      return path;
    },

    courseActionText() {
      let title = Kadenze.I18n.t('dict.view');
      if (this.course.current_user) {
        if (this.course.current_user.is_student) {
          if (this.archived) {
            title = Kadenze.I18n.t('dict.view');
          } else {
            title = Kadenze.I18n.t('dict.enter');
          }
        } else if (this.is_instructor_or_admin) {
          if (this.draft || this.upcoming || this.course.is_denied) {
            title = Kadenze.I18n.t('dict.edit');
          } else if (this.archived) {
            title = Kadenze.I18n.t('dict.view');
          } else {
            title = Kadenze.I18n.t('dict.teach');
          }
        } else if (this.course.current_user.is_locked) {
          if (this.upcoming) {
            title = Kadenze.I18n.t('dict.view');
          } else {
            title = Kadenze.I18n.t('dict.enter');
          }
        }
      }

      return title;
    },

    instructorsText() {
      return `${this.course.instructor_names} ${this.course.guest_lecturer_text}`;
    },

    shareModalParams() {
      return {
        modal_title: 'Share Course',
        shareableObj: {
          id: this.course.id,
          title: this.course.name,
          description: this.course.description,
          share_url: this.course.course_share_url
        },
        emailShareCb: this.shareCourse
      };
    },
  },

  methods: {
    courseAction(e) {
      if (this.course.current_user && (this.course.is_cohort_locked || this.course.current_user.is_locked)) {
        if (this.course.is_cohort_locked) {
          if (moment().isAfter(this.course.next_cohort_occurrence)) {
            this.course.is_cohort_locked = false;
            return;
          } else {
            this.$emit('locked-cohort', this.course)
          }
        } else if (this.course.current_user.is_locked) {
          if (this.course.prerequisite_courses.length > 0) {
            this.$emit('course-locked', this.course)
          } else {
            this.$emit('course-unlock', this.course)
          }
        }
        setTimeout(NProgress.done, 100);
        if (e) {
          e.preventDefault();
        }
      }
    },

    share() {
      this.$emit('share', this.shareModalParams)
    },

    shareCourse(item, emails) {
      let url = Kadenze.Routes.share_course_path(item.id, {emails: emails});
      let method = 'PATCH';

      Kadenze.UIUtil.makeRequest(url, method, null, parent.$el, null, function (data, textStatus, xhr) {
        new Kadenze.Notice.success(data);
      }, function (xhr, textStatus, errorThrown) {
        new Kadenze.Notice.error(xhr.responseJSON);
      });
    },

    i18nTranslations(text) {
      return I18n.t(text);
    }
  },

  mounted() {
    if (this.course.trigger_course_action) {
      this.courseAction();
    }
  }
}
</script>
